module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": _vm.loading,
      "fixed": true
    }
  }) : _vm._e(), _vm._v(" "), _c('ClientColorButton', {
    staticClass: "mb-4",
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": _vm.saveCopyTo
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("zoneGroups.copyTo") + " -> " + (_vm.copyTo === "dashboard" ? _vm.$t("zoneGroups.zonesForDashboard") : _vm.$t("zoneGroups.zonesForRight"))) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "zone-groups-columns"
  }, [_c('div', {
    staticClass: "zone-groups-column"
  }, [_c('ZoneGroupsTable', {
    attrs: {
      "title": _vm.$t('zoneGroups.availableZones'),
      "brand-zones": _vm.availableBrandZonesFiltered,
      "checked-zones": _vm.checkedZonesToBelong
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "zone-groups-arrows"
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('button', {
    staticClass: "btn zone-groups-btn-switch mb-4",
    on: {
      "click": function($event) {
        _vm.toBelong()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right fa-lg"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn zone-groups-btn-switch",
    on: {
      "click": function($event) {
        _vm.toNotBelong()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "zone-groups-column"
  }, [_c('ZoneGroupsTable', {
    attrs: {
      "title": _vm.$t('zoneGroups.zonesToBelong'),
      "brand-zones": _vm.brandZonesBelongingFiltered,
      "checked-zones": _vm.checkedZonesToNotBelong
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6152f770","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/zoneGroups/ZoneGroupsTab.vue
// module id = 3220
// module chunks = 0